export enum ChargingSessionsFilterStatusEnum {
  isPending = 'isPending',
  isTerminated = 'isTerminated',
}
